var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.39122 6H12.6956V21.8261H5.39122C5.06835 21.8261 4.7587 21.6978 4.53039 21.4695C4.30209 21.2412 4.17383 20.9316 4.17383 20.6087V7.21739C4.17383 6.89452 4.30209 6.58487 4.53039 6.35657C4.7587 6.12826 5.06835 6 5.39122 6Z",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6953 21.8261L18.7823 34C20.0738 34 21.3123 33.487 22.2256 32.5737C23.1388 31.6605 23.6518 30.4219 23.6518 29.1304V25.4783H33.391C33.7363 25.4782 34.0777 25.4046 34.3925 25.2624C34.7073 25.1203 34.9882 24.9127 35.2166 24.6537C35.445 24.3946 35.6157 24.0899 35.7173 23.7598C35.8189 23.4297 35.8491 23.0818 35.806 22.7391L33.9799 8.13043C33.9058 7.54217 33.6195 7.00116 33.1749 6.60892C32.7303 6.21668 32.1578 6.00017 31.5649 6H12.6953",
    stroke: "#051B46",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotVerified);
export default __webpack_public_path__ + "static/media/not-verified.3c66ada2ca13d6d6ed7ebdc73034dd5a.svg";
export { ForwardRef as ReactComponent };